import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SkeletonGoogleAdPreviewCard from './Skeleton'
import GoogleAssetsSliderPreview from '../../../../../../forms/Google/AdForms/GoogleAssetsSliderPreview'
import InternalAdActionButtons from '../../../InternalAdActionButtons'
import AdCardDetails from '../../../../../../features/components/AdCardListItem/AdCardDetails'
import useInternalAdSelfAccountName from '../../../../../../features/hooks/internalAdHooks/useInternalAdSelfAccountName'

import { getAdGoogleTransformedValues } from '../../../../../../forms/Google/AdForms/AdGoogleEdit/helpers'
import { useClearApproveInternalAd } from '../../../hooks'

import { openForm } from '../../../../../../modules/actions/forms'
import { approveInternalAd } from '../../../../../../modules/actions/ads'
import {
  approveInternalAdIsLoadingSelector,
  disapproveInternalAdIsLoadingSelector
} from '../../../../../../modules/selectors/ads'

import { AD_GOOGLE_EDIT } from '../../../../../../constants/forms'

import useStyles from '../../../../../../styles/common/adPreviewCard'

// this component currently support only ad approvals page style
const GoogleAdPreviewCard = ({ ad, disapproveInternalAdHandler }) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const { id: adId, name: adName } = ad

  const internalAdIsApproving = useSelector(approveInternalAdIsLoadingSelector(adId))
  const internalAdIsDisapproving = useSelector(disapproveInternalAdIsLoadingSelector(adId))
  useClearApproveInternalAd(adId)

  const adSelfAccountName = useInternalAdSelfAccountName(ad)

  const transformedAssetGroupValues = useMemo(() => getAdGoogleTransformedValues(ad), [ad])

  const approveInternalAdHandler = useCallback(() => {
    dispatch(approveInternalAd(adId))
  }, [dispatch, adId])

  const editInternalAdHandler = useCallback(() => {
    dispatch(openForm({ id: adId, formName: AD_GOOGLE_EDIT, otherParams: 'internal=true' }))
  }, [dispatch, adId])

  if (internalAdIsApproving || internalAdIsDisapproving) {
    return <SkeletonGoogleAdPreviewCard />
  }

  return (
    <div className={classes.cardListItem}>
      <div className={classes.cardSliderPreviewWrapper}>
        <GoogleAssetsSliderPreview values={transformedAssetGroupValues} showSearchPreview={false} />
      </div>
      <AdCardDetails title={adName} subTitle={adSelfAccountName} />
      <InternalAdActionButtons
        approveInternalAdHandler={approveInternalAdHandler}
        editInternalAdHandler={editInternalAdHandler}
        disapproveInternalAdHandler={disapproveInternalAdHandler}
      />
    </div>
  )
}

export default GoogleAdPreviewCard
